import NumberWidget from 'app/common/components/widgets/number';
import ParagraphText from 'app/common/components/widgets/paragraph-text';
import SingleLineText from 'app/common/components/widgets/single-line-text';
import { fromJS } from 'immutable';
import type { JSONSchema7 } from 'json-schema';
import type { FromSchema } from 'json-schema-to-ts';

export const EVAL_FORM_NAME = 'evalForm';

const jsonSchema = {
  type: 'object',
  properties: {
    name: {
      type: 'string'
    },
    step: {
      type: 'integer',
      minimum: 0
    },
    prompt: {
      type: 'string'
    }
  },
  additionalProperties: false,
  required: ['name']
} as const satisfies JSONSchema7;

export const schema = fromJS(jsonSchema);

export type EvalFormState = FromSchema<typeof jsonSchema>;

export const config = fromJS({
  order: ['name', 'step', 'prompt'],
  wrapper: 'noWrapper',
  properties: {
    name: {
      widget: 'singleLineText'
    },
    step: {
      widget: 'number',
      instructions: 'Leave blank to evaluate the whole transcript'
    },
    prompt: {
      widget: 'paragraphText'
    }
  }
});

export const widgets = {
  noWrapper: ({ children }: { children: React.ReactNode }) => children,
  number: NumberWidget,
  singleLineText: SingleLineText,
  paragraphText: ParagraphText
};
